import { configureStore } from "@reduxjs/toolkit";
import gamesReducer from "../features/games/games.feature";
import playersReducer from "../features/players/players.feature";
import sortingReducer from "../features/sorting/sorting.feature";
import tournamentsReducer from "../features/tournaments/tournaments.feature";

export const store = configureStore({
  reducer: {
    players: playersReducer,
    games: gamesReducer,
    tournaments: tournamentsReducer,
    sorting: sortingReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
